import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import TrainerPortalApp from './TrainerPortalApp';

const App = () => {
  return (
    <AuthProvider>
      <TrainerPortalApp />
    </AuthProvider>
  );
};

export default App;
